/* eslint-disable no-unused-vars */
/* eslint-disable no-unreachable */
import { useState, createContext, useEffect, useMemo } from 'react';
// import { webSocketConnection } from 'services/sockets';
import { clearCookie, getCookie, setCookie } from 'helpers/common';
import Toast from 'components/molecules/Toast';
import authService from 'services/authService';
import { useNavigate } from 'react-router-dom';

import { useCancellablePromise } from 'helpers/promiseHandler';
import notificationService from 'services/notificationService';

const context = {};

export const AuthContext = createContext(context);

export function AuthContextProvider(props) {
  const [province, setProvince] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(!!getCookie(process.env.REACT_APP_BMP_TOKEN_COOKIE));
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [notifications, setNotifications] = useState({});
  const [permissions, setPermissions] = useState({});
  const [loading_user, setLoadingUser] = useState(false);
  const [fetch_user, setFetchUser] = useState(false);
  const { cancellablePromise } = useCancellablePromise();
  const [reFetch, setRefetch] = useState(false);
  const [showTokenModal, setShowTokenModal] = useState(false);
  const history = useNavigate();
  const [allowedPages, setAllowedPages] = useState(
    JSON.parse(getCookie(process.env.REACT_APP_BMP_ALLOWED_PAGES_COOKIE)) || [],
  );
  const onLogout = async () => {
    clearCookie(process.env.REACT_APP_BMP_TOKEN_COOKIE);
    clearCookie(process.env.REACT_APP_BMP_ALLOWED_PAGES_COOKIE);
    setLoadingUser(false);
    setIsLoggedIn(false);
  };

  useEffect(() => {
    function listenCookieChange(callback, interval) {
      let old_bmp_token = getCookie(process.env.REACT_APP_BMP_TOKEN_COOKIE);
      setInterval(() => {
        const new_bmp_token = getCookie(process.env.REACT_APP_BMP_TOKEN_COOKIE);
        if (new_bmp_token !== old_bmp_token) {
          try {
            callback(new_bmp_token, process.env.REACT_APP_BMP_TOKEN_COOKIE);
          } finally {
            old_bmp_token = new_bmp_token;
          }
        }
      }, interval);
    }
    listenCookieChange((value, cookie) => {
      if (cookie === process.env.REACT_APP_BMP_TOKEN_COOKIE) {
        if (!value) {
          onLogout();
        }

        // check time out and then logout
      }
    }, 1000);
  }, []);

  const getPermissions = () => {
    setLoadingUser(true);

    cancellablePromise(authService.getCurrentUser())
      .then(res => {
        // eslint-disable-next-line no-unsafe-optional-chaining
        // setAllowedPages([
        //   // eslint-disable-next-line no-unsafe-optional-chaining
        //   ...res?.permissions_comp?.filter(p => p?.includes('.nav')).map(p => p.split('.')[1]),
        //   'comparison-process',
        // ]);
        setAllowedPages([
          'dashboard',
          'products',
          'campaigns',
          'brand-users',
          'product-groups',
          'completed-campaigns',
          'planned-campaigns',
          'ongoing-campaigns',
          'upload-history',
        ]);
        setCookie(
          process.env.REACT_APP_BMP_ALLOWED_PAGES_COOKIE,
          JSON.stringify([
            'dashboard',
            'products',
            'campaigns',
            'brand-users',
            'product-groups',
            'completed-campaigns',
            'planned-campaigns',
            'ongoing-campaigns',
            'upload-history',
          ]),
        );
        setAllowedPages([...res.permissions.filter(p => p.includes('.nav')).map(p => p.split('.')[1])]);
        // setCookie(
        //   process.env.REACT_APP_POS_ALLOWED_PAGES_COOKIE,
        //   JSON.stringify(res.permissions_comp?.filter(p => p.includes('.nav')).map(p => p.split('.')[1])),
        // );
        setLoadingUser(false);
        setUser(res?.user);
        setPermissions(res.permissions_comp);
      })
      .catch(err => {
        // setAllowedPages(['no-permissions']);
        // setCookie(process.env.REACT_APP_POS_ALLOWED_PAGES_COOKIE, JSON.stringify(['no-permissions']));
        setAllowedPages([
          'dashboard',
          'products',
          'campaigns',
          'brand-users',
          'product-groups',
          'completed-campaigns',
          'planned-campaigns',
          'ongoing-campaigns',
          'upload-history',
          'settings',
          'accounts',
          'support',
          'message',
          'products.nav',
          'performance-review',
          'demographics',
          'geolocation',
          'purchase-habits',
          'next-best-actions',
          'activate-account',
        ]);
        setCookie(
          process.env.REACT_APP_BMP_ALLOWED_PAGES_COOKIE,
          JSON.stringify([
            'dashboard',
            'products',
            'campaigns',
            'brand-users',
            'settings',
            'product-groups',
            'completed-campaigns',
            'planned-campaigns',
            'ongoing-campaigns',
            'upload-history',
            'support',
            'message',
            'products.nav',
            'performance-review',
            'demographics',
            'geolocation',
            'purchase-habits',
            'next-best-actions',
            'activate-account',
          ]),
        );
        // setAllowedPages([...res.permissions.filter(p => p.includes('.nav')).map(p => p.split('.')[1])]);
        // setCookie(
        //   process.env.REACT_APP_POS_ALLOWED_PAGES_COOKIE,
        //   JSON.stringify(res.permissions_comp?.filter(p => p.includes('.nav')).map(p => p.split('.')[1])),
        // );
        setIsLoggedIn(true);
        setLoadingUser(false);
        const existingUser = JSON.parse(localStorage.getItem('user'));
        console.log(existingUser);
        if (existingUser && existingUser.company_id) {
          setUser(existingUser);
        } else {
          setUser({
            company_name: 'User',
            company_logo: '',
            company_address: {
              street_address: 12345,
              city: 'TO',
              state: '',
              postal_code: '1Q1Q1Q1Q',
              place_id: '',
              country: 'CA',
              latlng: '',
            },
            primary_contact_person: 'Atif',
            primary_contact_number: '+92090078601',
            status: 'Active',
            website: 'veonpay.com',
            approved_by: 'Ali',
            created_by: 'Faiez',
            ambassador: 'fassih',
            email: 'abs@xyc.com',
            is_email_verified: false,
          });
        }
        // Toast({
        //   type: 'error',
        //   message: err.message,
        // });
      });
  };
  const getNotifications = async () => {
    await notificationService
      .getNotifications()
      .then(res => {
        setNotifications(res?.notifications);
      })
      .catch(err => {
        console.log(err);
        // Toast({
        //   type: 'error',
        //   message: err.message,
        // });
      });
  };
  /**
   * @description - This function is used to fetch the user details from the server
   */
  // useEffect(() => {
  //   // getPermissions();

  //   // listen to event
  //   // window.addEventListener('FETCH_ADMIN_ROLE', () => {
  //   //   getPermissions();
  //   // });
  //   // return () => {
  //   //   window.removeEventListener('FETCH_ADMIN_ROLE', () => {
  //   //     getPermissions();
  //   //   });
  //   // };
  // }, []);

  useEffect(() => {
    if (isLoggedIn) {
      // window.dispatchEvent(new Event('FETCH_ADMIN_ROLE'));
      getPermissions();
      getNotifications();
    }
  }, [isLoggedIn]);
  const onLogin = async ({ email, password }) => {
    setLoadingUser(true);
    try {
      const res = await authService.login({
        email,
        password,
      });

      if (!res?.accessToken) {
        throw new Error(res?.message);
      }

      setCookie(process.env.REACT_APP_BMP_TOKEN_COOKIE, res.accessToken);
      setIsLoggedIn(true);
      setLoadingUser(false);
    } catch ({ message }) {
      setIsLoggedIn(true);
      setLoadingUser(false);
      // Toast({ type: 'error', message });
    }
  };

  const onSignUp = async ({ values }) => {
    await authService
      .signUp(values)
      .then(res => {
        if (res.success) {
          Toast({
            type: 'success',
            message:
              res?.message ??
              res ??
              'User Created Successfully, An email for verification has sent at your given email kindly verify it',
          });
          history('/');
        } else {
          Toast({
            type: 'error',
            message: res?.message ?? res ?? 'Something Went Wrong',
          });
        }
      })
      .catch(reason => {
        Toast({
          type: 'success',
          message: 'User Created Successfully, An email for verification has sent at your given email kindly verify it',
        });
        history('/');
      });
  };
  const onResendEmail = async ({ values }) => {
    setLoading(true);
    await authService
      .resendEmail(values)
      .then(res => {
        if (res.success) {
          Toast({
            type: 'success',
            message: res?.message ?? res ?? 'Something Went Wrong',
          });
        } else {
          Toast({
            type: 'error',
            message: res?.message ?? res ?? 'Something Went Wrong',
          });
        }
        setLoading(false);
        onLogout();
        history('/');
      })
      .catch(reason => {
        setLoading(false);
        Toast({
          type: 'error',
          message: reason?.message ?? 'Something Went Wrong',
        });
      });
  };
  const hasPermission = perm => permissions?.includes(perm);
  const allContext = useMemo(
    () => ({
      setIsLoggedIn,
      onLogout,
      onLogin,
      onSignUp,
      onResendEmail,
      refetch: () => setRefetch(_ => !_),
      fetchUser: () => setFetchUser(() => !fetch_user),
      setShowTokenModal,
      setLoading,
      hasPermission,
      setProvince,
      province,
      allowedPages,
      showTokenModal,
      loading,
      isLoggedIn,
      fetch: reFetch,
      user,
      setUser,
      notifications,
      setNotifications,
      loading_user,
    }),
    [isLoggedIn, onLogin, onSignUp, onResendEmail, user, hasPermission, reFetch],
  );
  return <AuthContext.Provider value={allContext}>{props.children}</AuthContext.Provider>;
}
